module.exports = __webpack_public_path__ + "static/media/arjun_norway.81c19750.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/graphics/arjun_norway.jpeg
// module id = 85
// module chunks = 0